import { setAgrEnvironment, AgrProcessEnv, AgrEnvironment } from '@next/core-lib/environment';

export class Environment extends AgrEnvironment {
  DAIRY_RESULTS_URL: string;
  DAIRY_RATION_URL: string;

  constructor(env: Environment) {
    super(env);
  }
}

export const setEnvironment = ({
  DAIRY_RESULTS_URL,
  DAIRY_RATION_URL,
  APP_INSIGHTS_KEY,
  KUBE_POD_NAME,
  KUBE_NODE_NAME,
  KUBE_TEAM,
  ...env
}: AgrProcessEnv): Environment =>
  // App Insights in core-lib requires Kubernetes metadata.
  // For local/non-k8s runs we disable App Insights when those values are absent.
  new Environment({
    DAIRY_RESULTS_URL,
    DAIRY_RATION_URL,
    ...setAgrEnvironment({
      ...env,
      APP_INSIGHTS_KEY:
        APP_INSIGHTS_KEY && KUBE_POD_NAME && KUBE_NODE_NAME && KUBE_TEAM ? APP_INSIGHTS_KEY : '',
      KUBE_POD_NAME,
      KUBE_NODE_NAME,
      KUBE_TEAM,
    }),
  });
